// O que `GET activity/ludic-trail/collection` devolve, traduzido para o que o
// núcleo espera. Função PURA: não faz HTTP.
//
// Mora em `ava/` e não em `nucleo/` porque o formato é do BACKEND DESTE AVA —
// `cardId`/`obtainedAt` em camelCase, que é o que `LudicTrailController@collection`
// monta. O núcleo recebe um mapa de ids e não sabe que existe servidor; é a mesma
// divisão de `sincronia.js`, que monta o corpo do POST aqui e não lá.

/**
 * A resposta do servidor virada em mapa `cardId → data de conquista`.
 *
 * MAPA E NÃO LISTA, porque quem consome pergunta "o aluno tem esta carta?" uma vez
 * por carta do acervo — 44 hoje, 110 nas cinco regiões. Com lista, cada pergunta
 * seria uma varredura; com mapa é acesso direto, e o cruzamento inteiro fica linear
 * no tamanho do acervo.
 *
 * O que o mapa NÃO guarda, de propósito: `region` e `rarity`. Os dois já vêm do
 * catálogo, que é a fonte de verdade deles — o `card_id` carrega a região no
 * prefixo, e a raridade é intrínseca à carta. Guardar a cópia do servidor abriria a
 * chance de a tela mostrar uma coisa e o catálogo outra, e o backend grava o que o
 * cliente mandou (ver `LudicTrailCollection::reconcile`), então a cópia é a menos
 * confiável das duas.
 *
 * @param {Array} cards `data.cards` da resposta
 * @returns {object} mapa cardId → `obtainedAt` (ou `null`)
 */
export function possuidosDoServidor(cards) {
  if (!Array.isArray(cards)) return {};

  return cards.reduce((mapa, card) => {
    if (!card || typeof card.cardId !== "string" || !card.cardId) return mapa;

    // Se o mesmo id vier duas vezes (não deveria — `card_id` é único por aluno na
    // reconciliação —, mas a resposta vem da rede), a PRIMEIRA vence: o endpoint
    // ordena por `obtained_at`, então a primeira é a mais antiga, e a coleção guarda
    // quando o aluno conquistou, não quando reconquistou.
    if (Object.prototype.hasOwnProperty.call(mapa, card.cardId)) return mapa;

    return { ...mapa, [card.cardId]: card.obtainedAt || null };
  }, {});
}

export default possuidosDoServidor;
